export default __webpack_public_path__ + "static/media/hero_mobile.9cff29fa.png";